
<script setup>
import { ref } from 'vue';
import { __ } from '@/utils'
import Modal from "@components/modal.vue";
import Loader from '@components/loader.vue';

const emit = defineEmits(['payment', 'close']);
defineProps(['apiPayment', 'loadingUpdate', 'openPayment']);
</script>

<template>
	<Modal :isActive="openPayment" @close="emit('close')" class="popup--subscription">
		<template #head>
			<h3 class="popup__title">
				{{ __('Update payment method') }}
			</h3>
		</template>
		<template #body>
			<p class="details-item-header">{{ __('To update the payment method, please enter the following details') }}</p>
			<Loader v-if="loadingUpdate"  color="#2563eb" />
			<iframe id="payment-iframe" :src="apiPayment?.data?.url" style="width:100%;" frameborder="0"></iframe>
		</template>
	</Modal>
</template>